import React, { act, useEffect, useState, useRef } from "react";
import {
    Typography,
    Box,
    IconButton,
    Grid,
    Divider,
    Stack,
    Button,
    Modal,
    DialogContentText,
} from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CreateNewButton from "../commoncomponents/CreateNewButton";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import axios from "axios";
import { getAuthToken, getFacilityId, getuserId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import {
    ErrorChips,
    SuccessChips,
    WarningChips,
} from "../../assets/styled-components/chips";
import CloseButton from "../commoncomponents/CloseButton";
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import {
    checkHyperLink,
    updateOutsourceDetails,
    updateWorkOrderStatus,
} from "../../redux/actions/workOrderActionTypes";
import { set } from "react-hook-form";
import PageLoader from "../commoncomponents/PageLoader";
import commonMessages from "../../utility/constant";
import { FieldAlreadyExistsError } from "pdf-lib";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import CloseIcon from "@mui/icons-material/Close";
import Email from "../../assets/images/EmailLogo.png";
import Outlook from "../../assets/images/Outlook.png";
import Whatsapp from "../../assets/images/Whatsapplogo.png";
import CustomDialog from "../commoncomponents/CustomDialog";
import { Token } from "@mui/icons-material";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { createRoot } from 'react-dom/client';
import Workreport from "./Workreport";
import Unscheduleworkreport from "./Unscheduleworkreport";
import SignatureGrid from "./SignatureGrid";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1250px",
    height: "100%",
    maxHeight: "calc(100% - 64px)",
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
    overflowY: "auto",
    overflowX: "hidden",
};

const WorkOrderSummaryList = () => {

    const StyledCardTab = styled(Button)(({ theme }) => ({
        padding: "16px",
        flexDirection: "column",
        flex: 1,
        alignItems: "start",
        borderRadius: 0,
        gap: "4px",
        textTransform: "capitalize",
        "&.active": {
            backgroundColor: "#F6F2FA",
            "& .count": {
                color: theme.palette.primary.main,
            },
        },
        "&:hover": {
            "& .count": {
                color: theme.palette.primary.main,
            },
        },
    }));
    // const[Loading ,setLoading]=useState(false);
    const printRef = useRef()
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location?.state?.tab || 0);
    const [filteredRows, setFilteredRows] = useState([]);
    const [allCount, setAllCount] = useState(0);
    const [scheduledCount, setScheduledCount] = useState(0);
    const [unscheduledCount, setUnscheduledCount] = useState(0);
    const [workrequestCount, setWorkrequestCount] = useState(0);
    const [pdmscheduledCount, setPdmscheduledCount] = useState(0);
    const [rischeduledCount, setRischeduledCount] = useState(0);
    const [gridApi, setGridApi] = useState({});
    const facilityid = getFacilityId();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [signatureDialog, setSignatureDialog] = useState(false);


    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGT001");
    const roleName = localStorage.getItem("roleName");
    const deptVendorAccess = (roleName === "Vendors" || roleName === "DeptUser") ? true : false;

    const [pageLoading, setPageLoading] = useState(false)

    const [noAccessDialog, setNoAccessDialog] = useState(false); // State to manage "No Access" dialog visibility
    const [selectedRow, setSelectedRow] = useState(null); // State to store selected row data


    const allowedEmailRoles = ["FMSExec", "HospitalFM", "Helpdesk"];
    const currentRole = localStorage.getItem("roleName");
    const canRenderEmailProp = allowedEmailRoles.includes(currentRole);
    const [data, setData] = useState([]);
    const [serviceType, setServiceType] = useState("");
    const [isView, setIsView] = useState(false);

    // useEffect(() => {
    //     if (tab === 0) {
    //         //setActiveTab(tab)
    //     }
    //     else
    //     {
    //         setActiveTab(tab)
    //     }
    // }, [location])

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        outline: "none",
        borderRadius: "10px",
    };
    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    };

    const handleLinkClick1 = (rowData) => (event) => {
        event.preventDefault(); // Prevent default anchor behavior

        const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
        const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";

        // Dispatch Redux actions
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch({
            type: "SERVICE&CATEGORY_TYPE",
            payload: { category: categoryType }
        });
        dispatch(checkHyperLink("ISHYPERLINK_DATA", true));
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }));

        const title = `Edit ${rowData?.title || ""} Work Order`;

        // Function to generate a random AES key and export it
        async function generateAndExportKey() {
            const key = await crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, true, ["encrypt", "decrypt"]);
            const exportedKey = arrayBufferToBase64(await crypto.subtle.exportKey("raw", key));
            return { key, exportedKey };
        }

        // Function to encrypt data using AES-GCM and return encrypted data, IV, and key
        async function encryptData(data) {
            const encoder = new TextEncoder();
            const encodedData = encoder.encode(JSON.stringify(data));
            const iv = crypto.getRandomValues(new Uint8Array(12));

            const { key, exportedKey } = await generateAndExportKey();
            const encryptedData = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encodedData));

            return { encryptedState: arrayBufferToBase64(encryptedData), iv: arrayBufferToBase64(iv), exportedKey };
        }

        // Function to convert ArrayBuffer to Base64
        const arrayBufferToBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));

        // Prepare the data
        const newState = {
            isHyperlink: true,
            service: serviceType,
            readOnly: false,
            editmode: true,
            category: categoryType,
            id: rowData?.id || "",
            title,
            workordertype: rowData?.workordertype || "",
            year: year?.value,
            month: { value: month?.value, label: month?.label, id: month?.id },
            isChange: true,
            isverify: rowData?.isverify,
            isresponse: rowData?.isresponse,
        };

        // Encrypt and open the new window
        encryptData(newState).then(({ encryptedState, iv, exportedKey }) => {
            const url = rowData?.title === "Routine Inspection"
                ? `/routineInspection/Workorder`
                : `/workorder/register`;

            window.open(`${url}?state=${encodeURIComponent(encryptedState)}&iv=${encodeURIComponent(iv)}&key=${encodeURIComponent(exportedKey)}`, "_blank");
        });

    };

    const isDeptUser = roleName === "DeptUser"; // Replace `userRole` with the actual variable that holds the user's role
    const [isAnyRowSelected, setIsAnyRowSelected] = useState(false);
    const [filterStatus, setFilterStatus] = useState(""); // Track the current filter status

    // Function to handle filter changes
    const onFilterChanged = (event) => {
        const allFilters = event.api.getFilterModel(); // Get all active filters
        const statusFilter = allFilters.status?.filter || ""; // Get the status filter value
        setFilterStatus(statusFilter); // Update the filter status in state
    };
    const allColumns = [
        ...(localStorage.getItem("roleName") !== "DeptUser" && access?.canAuthorize
            ? [{
                headerCheckboxSelection: true, // Show checkbox in the header
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: (params) => params.data.status === "Completed" || params.data.status === "Verified" || params.data.status === "Completed-Outsource", // Enable checkbox for "Completed" or "Verified" rows
                minWidth: 80,
                maxWidth: 80,
                width: 80,
                filter: false,
            }]
            : []),

        {
            field: "workorderno", headerName: "Work Order No.", width: 250, wrapHeaderText: false,
            cellRenderer: (params) => {
                const { workorderNo } = params.data;
                if (roleName === "DeptUser") {
                    // If DeptUser, just return plain text
                    return <span>{params.value}</span>;
                }
                return (
                    <a
                        href="/workorder/register" // Placeholder href for accessibility
                        onClick={handleLinkClick1(params?.data)}
                        style={{ textDecoration: 'underline', color: '#1a73e8' }}
                    >
                        {params.value}
                    </a>
                );
            },
        },
          {
            field: "status", headerName: "Status",
            cellRenderer: (params) => {
                if (params.value === "Closed" || params.value === "Verified" || params.value === "Completed" || params.value === "Completed-Outsource") {
                    return <SuccessChips label={params.value} />;
                }
                if (params.value === "In Progress" || params?.value === "In Progress-Outsource") {
                    return <WarningChips label={params.value} />;
                } else {
                    return <ErrorChips label={params.value} />;
                }
            },
            width: 250,
        },
        {
            field: "respondedby", headerName: "Responded by", width: 250, wrapHeaderText: false
        },
         ...(activeTab === 2 
            ? [{ field: "assigneeby", headerName: "Assignee", width: 250, wrapHeaderText: false }]
            : []),
      
         ...(activeTab === 2 
            ? [{ field: "transferto", headerName: "Transfer To", width: 250, wrapHeaderText: false }]
            : []),
        {
            field: "vendorname", headerName: "Vendor", width: 250, wrapHeaderText: false
        },
        { field: "assetNo", headerName: "Asset No.", width: 250, wrapHeaderText: false },
        { field: "assetDesc", headerName: "Asset Description", width: 250, wrapHeaderText: false },
        { field: "requestDetails", headerName: "Request Details", width: 250, wrapHeaderText: false },
        {
            field: "departmentDesc", headerName: "Department", width: 250, wrapHeaderText: false
        },
        {
            field: "locationName", headerName: "Location", width: 250, wrapHeaderText: false
        },
        {
            field: "typecodedescription", headerName: "Type Code Description", width: 250, wrapHeaderText: false
        },
        // { field: "resposetime", headerName: "Response Countdown", width: 250, wrapHeaderText: false},
        { field: "targetDateFormate", headerName: "Work Order Date", width: 250, wrapHeaderText: false },
        ...(activeTab !== 2
            ? [{ field: "schTargetDate", headerName: "Target Date", width: 250, wrapHeaderText: false }]
            : []),
        { field: "workgroup", headerName: "Work Group", width: 250, wrapHeaderText: false },
        { field: "workordertype", headerName: "W.O Type", width: 250, wrapHeaderText: false },
        { field: "service", headerName: "Service", width: 250, wrapHeaderText: false },
        { field: "resposeType", headerName: "Response Type", width: 250, wrapHeaderText: false },
        { field: "actiontaken", headerName: "Action Taken", width: 250, wrapHeaderText: false },
        { field: "completeddate", headerName: "Completion Date", width: 250, wrapHeaderText: false },
        ...(activeTab === 2 
            ? [{ field: "rating", headerName: "Rating", width: 250, wrapHeaderText: false ,
            cellRenderer: (params) => {
                if (params.value == null) return "";
                const maxStars = 5; // Maximum number of stars

                const filledStars = Array.from({ length: params.value }, (_, i) => (
                    <StarIcon key={`filled-${i}`} style={{ color: '#FFD700' }} />
                )); // Filled stars with gold color

                const emptyStars = Array.from(
                    { length: maxStars - params.value },
                    (_, i) => <StarBorderIcon key={`empty-${i}`} style={{ color: '#FFD700' }} />
                ); // Empty stars with gold color

                return [...filledStars, ...emptyStars]; // Combine filled and empty stars
            }, }]
            : []),
      

    ];
    const columns = isDeptUser
        ? allColumns // Only include these columns for DeptUser
        : allColumns.filter(column => !["actiontaken", "completeddate"].includes(column.field)); // Exclude these columns for others

    const [selectedRowIds, setSelectedRowIds] = useState([]); // Initialize state
    const [isDialogOpen, setIsDialogOpen] = useState(false); // State for dialog


    const onSelectionChanged = (event) => {
        
        const selectedRows = event.api.getSelectedRows();
        const selectedRowIds = selectedRows.map((row) => ({
            id: row.id,
            title: row.title,
            serveicename: row.service,
        }));
        setIsAnyRowSelected(selectedRowIds.length > 0);
        setSelectedRowIds(selectedRowIds); // Ensure selectedRowIds is an array
    };

    const handleAuthorize = async (row) => {

        try {
            const token = getAuthToken('id_token'); // Get auth token logic
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
         const userid = getuserId('UserId');
            let endpoint;
            if (row.serveicename === "FEMS") {
                endpoint = `${FemsGraph}/api/Graphfemworkorder/Authorizeworkorder/${row.id}/${row.title}/${userid}`;
            } else {
                endpoint = `${BemsGraph}/api/Graphbemworkorder/Authorizeworkorder/${row.id}/${row.title}/${userid}`;
            }

            // Sending PUT request
            await axios({
                method: 'put',
                url: endpoint,
                headers: config.headers,
            });
        } catch (error) {
            console.error(`Error in authorizing ${row.id}:`, error);
        }
    };


    const handleAuthorizeAll = async () => {
        for (const row of selectedRowIds) {
            setPageLoading(true);
            await handleAuthorize(row); // Process each row
            setPageLoading(false);
        }
        await fetchWorkOrders(); // Fetch work orders after all loops are completed
    };

    const openDialog = () => setIsDialogOpen(true); // Open dialog
    const closeDialog = () => setIsDialogOpen(false); // Close dialog

    const confirmAuthorization = async () => {
        closeDialog(); // Close dialog
        await handleAuthorizeAll(); // Call API
    };


    // Custom logic to ensure only "Completed" rows are selectable
    const isRowSelectable = (rowNode) => rowNode.data.status === "Completed" || rowNode.data.status === "Verified" || rowNode.data.status === "Completed-Outsource";


    const customColumns = {
        workorderno: "Work Order No.",
        respondedby: "Responded",
        vendorname: "Vendor",
        schTargetDate: "Target Date",
        targetDateFormate: "Work Order Date",
        status: "Status",
        maintenanceType: "Maintenance Type",
        workordertype: "W.O Type",
       // respondedby: "Assignee",
        assetDesc: "Asset Description",
        assetNo: "Asset No.",
        departmentDesc: "Department",
        locationName: "Location",
        service: "Service",
        workgroup: "Work Group",
        requestDetails: "Request Details",
    }

    if (roleName === "DeptUser" && (activeTab == 0 || activeTab == 2)) {
        columns.push({
            field: "respond",
            headerName: "Respond",
            cellRenderer: (params) => {
                // Show button only if maintenanceType is "Unscheduled"
                if (params.data.maintenanceType === "Unscheduled") {
                    const isDisabled =
                        (params.data.isresponse === "Yes") ||
                        (params.data.isresponse === "" && params.data.respondedby == null);
                    return (
                        <Button
                            variant="contained"
                            sx={{ width: 30, height: 30 }}
                            onClick={() => handleOpenModel(params.data)}
                            disabled={isDisabled} // Disable or enable based on the condition
                        >
                            Respond
                        </Button>
                    );
                } else {
                    // Do not render anything for "In Schedule" or other types
                    return null;
                }
            },
            width: 250,
        });
    }


    if (roleName === "DeptUser" && (activeTab == 0 || activeTab == 2 || activeTab == 1)) {
        columns.push({
            field: "Verify",
            headerName: "Verify",

            cellRenderer: (params) => {
                //workordertype:"PDM"

                // Show button only if maintenanceType is "Unscheduled"
                if ((params.data.workordertype !== "PDM" || params.data.workordertype !== "Routine Inspection") && (params.data.maintenanceType === "Unscheduled" || params.data.maintenanceType === "Scheduled") && (params.data.status === "Completed" || params.data.status === "Closed" || params.data.status === "Verified")) {
                    const isDisabled =
                        (params.data.isverify === "Yes");
                    return (
                        <Button
                            variant="contained"
                            sx={{ width: 30, height: 30 }}
                            onClick={() => handleOpenModelverify(params.data)}
                            disabled={isDisabled} // Disable or enable based on the condition
                        >
                            Verify
                        </Button>
                    );
                } else {
                    // Do not render anything for "In Schedule" or other types
                    return null;
                }
            },
            width: 250,
        });
    }

    const handleLinkClick = (deptid) => {
        // Dispatch actions
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }));

        // Prepare navigation state
        const title = `Create Unscheduled Work Order`;
        const deptData = {
            ...deptid,
            assetno: { label: deptid.assetno, value: deptid.assetId },
            categoryId: { label: deptid.categoryName, value: deptid.categoryId },
            typeId: { label: deptid.type, value: deptid.typeId },

        };

        // Navigate with state parameters
        navigate("/workorder/register", {
            state: {
                title, editmode: false, isHyperlink: false, isCreateMode: true, deptid: deptData, year: year?.value,
                month: { value: month?.value, label: month?.label, id: month?.id }
            },
        });
    };

    const tab3Columns = [
        {
            field: "deptworkrequestno",
            headerName: "Work Request No.",
            width: 180,
            cellRenderer: (params) => {
                const { status, workorderNo } = params.data;

                if (status === "Open" && localStorage.getItem("roleName") !== "DeptUser" && workorderNo === "") {
                    return (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default navigation
                                handleLinkClick(params.data); // Pass params.data directly
                            }}
                            style={{ textDecoration: "underline", color: "#1a73e8" }}
                        >
                            {params.value}
                        </a>
                    );
                }
                return params.value;
            },
        },

        {
            field: "deptWorkRequestDateFormate",
            headerName: "Work Request Date",
            width: 150,
            comparator: utils.dateComparator.bind(utils),
        },
        { field: "type", headerName: "Work Request Type", width: 180 },
        { field: "service", headerName: "Service", width: 180 },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            cellRenderer: (params) => {
                if (params.value === "Open") {
                    return <ErrorChips label={params.value} />;
                }
                if (params.value === "Closed") {
                    return <SuccessChips label={params.value} />;
                }
                return null;
            },
        },
        {
            field: "requestdetails",
            headerName: "Work Request Description",
            width: 150,
        }
    ];



    const [open, setOpen] = useState(false);
    const [selectedWorkOrderNo, setSelectedWorkOrderNo] = useState(null);
    const [selectedworkorderid, setSelectedworkorderid] = useState(null);
    const [selectedservice, setSelectedservice] = useState(null);

    const handleOpenModel = (rowData) => {

        setSelectedWorkOrderNo(rowData.workorderno);  // Ensure this matches the field name in rowData
        setSelectedworkorderid(rowData.id);
        setSelectedservice(rowData.service);

        setOpen(true);
    };

    const handleOpenModelverify = (rowData) => {
        const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
        const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
        dispatch({
            type: "SERVICE&CATEGORY_TYPE", payload: {
                assetType: serviceType,
                category: categoryType
            }
        });
        // setSelectedworkorderid(rowData.id);
        setSelectedRowData(rowData)
        setSignatureDialog(true);


    };

    const handleCloseModel = () => {
        setOpen(false);
        setOpenSuccessDialog(false);
        fetchWorkOrders();
    };

    const handleCloseWithoutFetch = () => {
        setOpen(false);
        setOpenSuccessDialog(false);
    };

    const handleSuccessDialog = () => {
        setOpenSuccessDialog(true); // Open success dialog
    };

    const changed = location?.state?.isChange;
    // console.log("changed",changed);
    // console.log("year",location?.state?.year);
    // console.log("month",location?.state?.month);

    const allMonths = commonMessages.months; // Assuming `commonMessages.months` is an array of month names.
    const all = { label: "All", value: "All", id: "0" };
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth();

    const [year, setYear] = useState(() => {
        const initialYear = location?.state?.year || currentYear.toString();
        return { label: initialYear, value: initialYear };
    });

    const [month, setMonth] = useState(() => {
        const initialMonth =
            location?.state?.month ||
            allMonths[currentMonthIndex]; // Default to current month if not in location.state            
        return initialMonth;
    });

    const [monthsOptions, setMonthsOptions] = useState([]);
    const [yearsOptions, setYearsOptions] = useState([]);

    const fetchMaintenanceYears = async () => {
        try {
            const maintenanceYearResponse = await axios.get(
                `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`
            );
            const years = maintenanceYearResponse.data.items.map(year => ({
                label: year.maintyearvalue.toString(),
                value: year.maintyearvalue.toString(),
            }));
            setYearsOptions(years || []);
        } catch (error) {
            console.error('Error fetching maintenance years:', error);
        }
    };

    useEffect(() => {
        const selectedYear = parseInt(year.value);
        const isNextYear = currentMonthIndex === 11;

        const months =
            selectedYear === currentYear
                ? [
                    all,
                    ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                    ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                ]
                : [all, ...allMonths]; // All months for previous years

        setMonthsOptions(months);

        if (!location?.state?.month) {

            setMonth(
                selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
            );
        }
    }, [year, location?.state?.month]);

    const handleYearChange = (newValue) => {
        if (newValue && newValue.value !== year?.value) {
            const selectedYear = parseInt(newValue.value);
            const currentDate = new Date();
            const currentMonthIndex = currentDate.getMonth();

            const months =
                selectedYear === currentYear
                    ? [
                        all,
                        ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                        ...(currentMonthIndex === 11 ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                    ]
                    : [all, ...allMonths]; // All months for previous years

            setYear(newValue); // Keep the selected year
            setMonthsOptions(months);
            setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]); // Default to the start of the year for future years
        }
    };

    const handleMonthChange = (newValue) => {
        setMonth(newValue);
    };

    useEffect(() => {

        if (year && month) {
            fetchWorkOrders();
            fetchtotalCount();
            fetchMaintenanceYears();
        }

    }, [activeTab, year, month]);

    const handleRefresh = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonthIndex = currentDate.getMonth();
        const nextMonthIndex = (currentMonthIndex + 1) % 12;
        const isNextYear = currentMonthIndex === 11;

        const monthsToShow = [
            all,
            ...allMonths.slice(0, currentMonthIndex + 1),
            ...(isNextYear ? [] : [allMonths[nextMonthIndex]]),
        ];

        setYear({ label: currentYear.toString(), value: currentYear.toString() }); // Set to current year
        setMonthsOptions(monthsToShow);
        setMonth(allMonths[currentMonthIndex]); // Set to current month

    };



    const fetchWorkOrders = async () => {
        setFilteredRows([]);
        setIsLoading(true);
        setPageLoading(true);
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            // const departmentid = localStorage.getItem("roleName") === "DeptUser"
            //     ? 1
            //     : localStorage.getItem("roleName") === "Technician"
            //         ? 2
            //         : 0;

            const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1: 0;
            const userid = localStorage.getItem("UserId");

            let responses = [];

            // Determine which API endpoints to call based on activeTab
            if (activeTab === 0) { // All Work Orders
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/Graphfemworkorder/GetCombinedWorkOrderSchedules/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/Graphbemworkorder/GetCombinedWorkOrderSchedules/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);
            } else if (activeTab === 1) { // Scheduled Work Orders
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);
            } else if (activeTab === 2) { // Unscheduled Work Orders
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderlistfemunSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderlistbemunSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);
            } else if (activeTab === 3) { // Department Requests
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);
            } else if (activeTab === 4) { // Department Requests
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemPDMSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemPDMSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);

            } else if (activeTab === 5) { // Department Requests
                responses = await Promise.all([
                    axios.get(
                        `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemRISchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                    axios.get(
                        `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemRISchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
                        config
                    ),
                ]);
            }

            // Combine the data from all responses
            const allItems = responses
                .map((response) => response.data.items.map((data) => ({
                    ...data,
                    targetDateFormate: utilities.formatDate({ dateString: data?.targetDateFormate, format: "dd/mm/yy" })
                })) || [])
                .flat();

            // Filter or map data based on the active tab
            let formattedData = [];
            if (activeTab === 3) {
                // Filter the items where workorderNo is an empty string
                formattedData = allItems
                    .filter((item) => item.workorderNo === "" && item.status === "Open")
                    .map((item) => ({
                        ...item,
                        deptWorkRequestDateFormate: utilities.formatDate({ dateString: item?.deptWorkRequestDateFormate, format: "dd/mm/yy" })
                    }));
            } else {
                // Use all items without filtering
                formattedData = allItems.map((item) => ({
                    ...item,
                    deptWorkRequestDateFormate: utilities.formatDate({ dateString: item?.deptWorkRequestDateFormate, format: "dd/mm/yy" })
                }));
            }

            setFilteredRows(formattedData.map((data) => ({
                ...data,
                enableDownload: data?.title === "Unscheduled" || data?.title === "Scheduled"
            })));
        } catch (error) {
            //  console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
            setPageLoading(false);
        }
    };




    const fetchtotalCount = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            // For Technician work order list 
            // const departmentid = localStorage.getItem("roleName") === "DeptUser"
            //     ? 1
            //     : localStorage.getItem("roleName") === "Technician"
            //         ? 2
            //         : 0;

            const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1: 0;
            var userid = localStorage.getItem("UserId");

            // Define the API endpoints
            const apiUrlFEMS = `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;
            const apiUrlBEMS = `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderCountsAsync/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;

            // Fetch data from both endpoints simultaneously
            const [responseFEMS, responseBEMS] = await Promise.all([
                axios.get(apiUrlFEMS, config),
                axios.get(apiUrlBEMS, config),
            ]);

            // Extract counts from both responses
            const femsCounts = responseFEMS.data || { totalCount: 0, scheduledCount: 0, unscheduledCount: 0, workrequestCount: 0, pdmscheduledCount: 0, rischeduledCount: 0 };
            const bemsCounts = responseBEMS.data || { totalCount: 0, scheduledCount: 0, unscheduledCount: 0, workrequestCount: 0, pdmscheduledCount: 0, rischeduledCount: 0 };

            // Combine counts from both services
            const totalCount = (localStorage.getItem("roleName") === "DeptUser"
                ? (femsCounts.departmentCount || 0) + (bemsCounts.departmentCount || 0)  // If "DeptUser", use departmentCount
                : (femsCounts.totalCount || 0) + (bemsCounts.totalCount || 0)  // Otherwise, sum femsCounts and bemsCounts
            ); const scheduledCount = (femsCounts.scheduledCount || 0) + (bemsCounts.scheduledCount || 0);
            const unscheduledCount = (femsCounts.unscheduledCount || 0) + (bemsCounts.unscheduledCount || 0);
            const workrequestCount = (femsCounts.workrequestCount || 0) + (bemsCounts.workrequestCount || 0);
            const pdmscheduledCount = (femsCounts.pdmscheduledCount || 0) + (bemsCounts.pdmscheduledCount || 0);
            const rischeduledCount = (femsCounts.rischeduledCount || 0) + (bemsCounts.rischeduledCount || 0);

            // Update state with combined counts
            setAllCount(totalCount);
            setScheduledCount(scheduledCount);
            setUnscheduledCount(unscheduledCount);
            setWorkrequestCount(workrequestCount);
            setPdmscheduledCount(pdmscheduledCount);
            setRischeduledCount(rischeduledCount);

        } catch (error) {
            //  console.error("Error fetching data", error);
        }
    };


    const handlecreate = () => {
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: { category: 'Unscheduled' } })
        // Dynamically set title by inserting the category name
        const title = `Create Unscheduled Work Order`;

        navigate("register", {
            state: {
                title, editmode: false, isHyperlink: false, isCreateMode: true, year: year?.value,
                month: { value: month?.value, label: month?.label, id: month?.id }
            }
        });
    };


    const handleEdit = (rowData) => {
        if (activeTab === 3) {
            navigate("/departmentworkrequest/register", {
                state: {
                    ...rowData,
                    year: year?.value,
                    month: { value: month?.value, label: month?.label, id: month?.id },
                    isChange: true,
                    isEditMode: true,
                    assetno: { label: rowData.assetno, value: rowData.assetId },
                    categoryId: { label: rowData.categoryName, value: rowData.categoryId },
                    typeId: { label: rowData.type, value: rowData.typeId },
                },
            });
        } else if (activeTab === 5 || (activeTab === 0 && rowData?.workordertype === "Routine Inspection")) {
            const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
            const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({
                type: "SERVICE&CATEGORY_TYPE", payload: {
                    assetType: serviceType,
                    category: categoryType
                }
            });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
            const title = `Edit ${rowData?.title || ""} Work Order`;
            navigate("/routineInspection/Workorder", { state: { ...rowData, service: serviceType, readOnly: false, editmode: true, category: categoryType, viewmode: false, isHyperlink: false, title } });
        } else {
            const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
            const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({
                type: "SERVICE&CATEGORY_TYPE", payload: {
                    assetType: serviceType,
                    category: categoryType
                }
            });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
            const title = `Edit ${rowData?.title || ""} Work Order`;
            navigate("register", {
                state: {
                    ...rowData, service: serviceType, readOnly: false, editmode: true, category: categoryType, viewmode: false, isHyperlink: false, title,
                    year: year?.value,
                    month: { value: month?.value, label: month?.label, id: month?.id },
                    isChange: true,
                }
            });
        }
    };


    const handleView = (rowData) => {
        if (activeTab === 3) {
            navigate("/departmentworkrequest/register", {
                state: {
                    ...rowData,
                    year: year?.value,
                    month: { value: month?.value, label: month?.label, id: month?.id },
                    isChange: true,
                    isViewMode: true,
                    assetno: { label: rowData.assetno, value: rowData.assetId },
                    categoryId: { label: rowData.categoryName, value: rowData.categoryId },
                    typeId: { label: rowData.type, value: rowData.typeId },
                },
            });
        } else if (activeTab === 5 || (activeTab === 0 && rowData?.workordertype === "Routine Inspection")) {
            const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
            const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({
                type: "SERVICE&CATEGORY_TYPE", payload: {
                    assetType: serviceType,
                    category: categoryType
                }
            });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
            const title = `View ${rowData?.title || ""} Work Order`;
            navigate("/routineInspection/Workorder", { state: { ...rowData, service: serviceType, readOnly: false, editmode: false, category: categoryType, viewmode: true, title } });
        } else {
            const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
            const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({
                type: "SERVICE&CATEGORY_TYPE", payload: {
                    category: categoryType
                }
            });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
            const title = `View ${categoryType} Work Order`;
            navigate("register", {
                state: {
                    ...rowData, service: serviceType, readOnly: false, editmode: false, category: categoryType, viewmode: true, title,
                    year: year?.value,
                    month: { value: month?.value, label: month?.label, id: month?.id },
                    isChange: true,
                }
            });

        }
    };

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);  // Update the active tab

    };

    const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
    const handleSave = async (rowData) => {
        try {
            const token = getAuthToken('id_token'); // Get auth token logic
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            let endpoint;
            if (selectedservice === "FEMS") {
                endpoint = `${FemsGraph}/api/Graphfemworkorder/Updatefemunschworkorderdatetime/${selectedworkorderid}`;
            } else {
                endpoint = `${BemsGraph}/api/Graphbemworkorder/Updatebemunschworkorderdatetime/${selectedworkorderid}`;
            }

            // Sending PUT request
            await axios({
                method: 'put',
                url: endpoint,
                headers: config.headers,
            });

            // After successful response, show the success dialog
            handleSuccessDialog();
        } catch (error) {
            //  console.error('Error in handling save:', error);
        }
    };

    const handleDialogClose = (e, reason, closeFunction) => {
        if (reason !== "backdropClick") {
            closeFunction();
        }
    };

    const [openModal, setOpenModal] = useState(false);
    const [openReportModal, setOpenReportModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [verifyDialog, setVerifyDialog] = useState(false);

    const extractAnchorTag = (htmlString) => {
        // Create a DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Find the <a> tag
        const anchorTag = doc.querySelector("a");
        return anchorTag ? anchorTag.outerHTML : null; // Return the <a> tag as a string
    };

    const isEmailEnabled = (rowData) => {
        if (!rowData) {
            return false; // If no row data, disable email
        }

        const { maintenanceType, resposeType, status } = rowData;

        // Allow roles: CorporateAdmin, FMSExec, HospitalFM, Helpdesk
        const allowedRoles = ["FMSExec", "HospitalFM", "Helpdesk"];
        const isValidRole = allowedRoles.includes(localStorage.getItem("roleName"));

        const isValidMaintenanceType =
            maintenanceType === "Unscheduled" || maintenanceType === "Scheduled"; // Check maintenance type
        const isOutsourceResponse = resposeType === "Outsource"; // Check response type
        const isInProgress = status === "In Progress"; // Check status
        const isTabValid = [0, 1, 2, 4].includes(activeTab); // Check active tab

        // Allow if all conditions are met
        return isValidRole && isTabValid && isValidMaintenanceType && isOutsourceResponse && isInProgress;
    };



    const handleEmail = (rowData) => {
        setOpenModal(true);

        const contentBody = rowData.contentbody; // contentBody is HTML, not JSON
        // Parse the HTML to extract the <a> tag
        const parser = new DOMParser();
        const doc = parser.parseFromString(contentBody, "text/html");

        // Get the <a> tag's href attribute
        const anchorTag = doc.querySelector("a");
        const extractedUrl = anchorTag ? anchorTag.href : null;

        if (!extractedUrl) {
            //  console.error("No URL found in the content body!");
            return;
        }

        // Update state with the selected row and extracted URL
        setSelectedRowData({ ...rowData, extractedUrl });
    };

    const handleEmailSend = (rowData) => {
        if (isEmailEnabled(rowData)) {
            handleEmail(rowData);
        } else {
            setSelectedRow(rowData);
            setNoAccessDialog(true);
        }
    };

    const handleCloseNoAccessDialog = () => {
        setNoAccessDialog(false);
    };

    // Usage of `CustomDialog` for "No Access"
    const NoAccessDialog = () => (
        <CustomDialog
            open={noAccessDialog}
            onClose={handleCloseNoAccessDialog}
            onConfirm={handleCloseNoAccessDialog}
            content="Send Option only applicable for Unscheduled and Scheduled Work Orders"
            cancelBtn={null}
            confirmBtn="OK"
        />
    );


    const handleOutlookClick = () => {

        if (!selectedRowData) {
            // console.error("No row data selected!");
            return;
        }

        const { workorderno, mailto, extractedUrl } = selectedRowData;

        // Constructing the plain-text body with a user-friendly "Click here" link
        const plainTextBody = `Please click here to update the Work Order: 
            ${extractedUrl}`;


        // Encoding the plain-text body and subject for the mailto link
        const encodedBody = encodeURIComponent(plainTextBody); // Encoding for compatibility
        const encodedSubject = encodeURIComponent(`${localStorage.getItem('FacilityName')} : ${workorderno}`);

        // Constructing the mailto link
        const mailtoLink = `mailto:${mailto}?subject= New Work Order Received from ${encodedSubject}&body=${encodedBody}`;


        // Triggering the mailto link
        window.location.href = mailtoLink;
    };

    const handleCloseModal = (event, reason) => {
        if (reason === "backdropClick") {
            return; // Prevent modal from closing on outside click
        }
        setOpenModal(false)
    }

    const encodeBodyContent = (content) => {
        return encodeURIComponent(content);
    };


    const handleWhatsAppClick = (rowData) => {

    };

    const handleEmailClick = (rowData) => {

    };
    const handleDownload = async (rowData) => {
        setPageLoading(true);

        const servicetype = rowData?.service === "FEMS" ? "FEMS" : "BEMS";
        const checkCategory =
            rowData?.maintenanceType === "Unscheduled"
                ? "GetUnScheduleWorkorderFetchByWorkOrderId"
                : "GetScheduleWorkorderFetchByWorkOrderId";

        try {
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId("facilityid");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };


            const baseUrl = servicetype === "FEMS" ? FemsGraph : BemsGraph;
            const url = `${baseUrl}/api/GraphWorkorderReport/${checkCategory}/${facilityId},${rowData?.id},${token}`;


            const response = await axios.get(url, config);


            setData(response?.data);
            setServiceType(rowData?.service);
            setSelectedRowData(rowData);


            const modalComponent =
                rowData?.title === "Unscheduled"
                    ? "Unscheduleworkreport"
                    : "Workreport";

            setOpenReportModal(modalComponent);


            setTimeout(async () => {
                await downloadPDF(rowData);
            }, 4000);

        } catch (error) {
            console.log("Error downloading the report:", error);

        } finally {
            // setPageLoading(false);
        }
    };


    const downloadPDF = async (rowData) => {
        setPageLoading(true);
        const fileName = `${rowData?.title === 'Unscheduled' ? 'Unscheduled' : 'Scheduled'}_WORK_ORDER.pdf`;

        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });


        const printElement = printRef.current;
        if (printElement) {
            const records = printElement.querySelectorAll('.record-paper');
            let pageNumber = 1;

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const addContentToPDF = (canvas, imgData) => {
                const imgWidth = pdfWidth;
                const imgHeight = (canvas.height * pdfWidth) / canvas.width;
                let yOffset = 0;

                while (yOffset < imgHeight) {
                    if (pageNumber > 1) {
                        pdf.addPage();
                    }

                    const sliceHeight = Math.min(pdfHeight, imgHeight - yOffset);
                    pdf.addImage(
                        imgData,
                        'PNG',
                        0,
                        -yOffset,
                        imgWidth,
                        imgHeight,
                        undefined,
                        'FAST'
                    );

                    // Add footer
                    pdf.setFontSize(8);


                    pageNumber++;
                    yOffset += pdfHeight;
                }
            };

            const processRecord = async (record, index) => {
                return html2canvas(record, {
                    scale: 2,
                    useCORS: true,
                })
                    .then((canvas) => {
                        const imgData = canvas.toDataURL('image/png');
                        addContentToPDF(canvas, imgData);

                        if (index === records.length - 1) {
                            // pdf.save(fileName);
                        }
                    })
                    .catch((error) => {
                        console.log('Error generating PDF:', error);
                    });
            };

            // Process all records and wait for all to complete
            await Promise.all(Array.from(records).map(processRecord));

            // Final PDF save with dynamic file name based on workordercategory
            pdf.save(fileName);
            setPageLoading(false); // Now, this will run only after all records are processed
            setOpenReportModal(false);

        }

    };


    const handleSignatureCloseDialog = () => {
        setSignatureDialog(false);
    };

    const handleSaveSignature = (id, data) => {
        setSignatureDialog(false);
        setVerifyDialog(true);
    };

    const handleConfirmRequestDialog = () => {
        setVerifyDialog(false);
        fetchWorkOrders();

    };

    const handleCloseRequestDialog = () => {
        setVerifyDialog(false);
    };

    return (
        <>
            <PageLoader open={pageLoading} />
            <PageTitle title={" Work Order Management"} />
            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>
                        <Grid item xs={13} md={9}>
                            <Stack
                                direction={"row"}
                                divider={<Divider orientation="vertical" flexItem />}
                                border={0.5}
                                borderColor={"divider"}
                                borderRadius={4}
                                overflow={"hidden"}
                                height={"100%"}
                            >
                                <StyledCardTab
                                    className={`${activeTab === 0 ? "active" : null}`}
                                    onClick={() => handleTabChange(0)}

                                >
                                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                        All Work Orders
                                    </Typography>
                                    <Typography
                                        className="count"
                                        color={"text.secondary"}
                                        fontSize={24}
                                        fontWeight={500}
                                    >
                                        {allCount}
                                    </Typography>
                                </StyledCardTab>
                                <StyledCardTab
                                    className={`${activeTab === 1 ? "active" : null}`}
                                    onClick={() => handleTabChange(1)}
                                >
                                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                        Scheduled Work Orders
                                    </Typography>
                                    <Typography
                                        className="count"
                                        color={"text.secondary"}
                                        fontSize={24}
                                        fontWeight={500}
                                    >
                                        {scheduledCount}
                                    </Typography>
                                </StyledCardTab>
                                <StyledCardTab
                                    className={`${activeTab === 2 ? "active" : null}`}
                                    onClick={() => handleTabChange(2)}
                                >
                                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                        Unscheduled Work Orders
                                    </Typography>
                                    <Typography
                                        className="count"
                                        color={"text.secondary"}
                                        fontSize={24}
                                        fontWeight={500}
                                    >
                                        {unscheduledCount}
                                    </Typography>
                                </StyledCardTab>
                                <StyledCardTab
                                    className={`${activeTab === 4 ? "active" : null}`}
                                    onClick={() => handleTabChange(4)}
                                >
                                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                        Predictive Maintenance (PDM)
                                    </Typography>
                                    <Typography
                                        className="count"
                                        color={"text.secondary"}
                                        fontSize={24}
                                        fontWeight={500}
                                    >
                                        {pdmscheduledCount}
                                    </Typography>
                                </StyledCardTab>
                                <StyledCardTab
                                    className={`${activeTab === 5 ? "active" : null}`}
                                    onClick={() => handleTabChange(5)}
                                >
                                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                        Routine Inspection  (RI)
                                    </Typography>
                                    <Typography
                                        className="count"
                                        color={"text.secondary"}
                                        fontSize={24}
                                        fontWeight={500}
                                    >
                                        {rischeduledCount}
                                    </Typography>
                                </StyledCardTab>
                                {(localStorage.getItem("roleName") !== "DeptUser" && !access?.canClose) && (
                                    <StyledCardTab
                                        className={`${activeTab === 3 ? "active" : ""}`}
                                        onClick={() => handleTabChange(3)}
                                    >
                                        <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                            New Work Requests
                                        </Typography>
                                        <Typography
                                            className="count"
                                            color={"text.secondary"}
                                            fontSize={24}
                                            fontWeight={500}
                                        >
                                            {workrequestCount}
                                        </Typography>
                                    </StyledCardTab>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>
                </DefaultCard>
            </Box>

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Box
                        mb={1}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                        }}
                    >
                        <SectionTitle
                            title={
                                activeTab === 3
                                    ? `New Work Requests List (${workrequestCount})`
                                    : activeTab === 0
                                        ? `All Work Orders List (${scheduledCount + unscheduledCount + rischeduledCount + pdmscheduledCount})`
                                        : activeTab === 1
                                            ? `Scheduled Work Orders List (${scheduledCount})`
                                            : activeTab === 2
                                                ? `Unscheduled Work Orders List (${unscheduledCount})`
                                                : activeTab === 5
                                                    ? `Routine Inspection (RI) (${rischeduledCount})`
                                                    : `Predictive Maintenance (PDM) (${pdmscheduledCount})`
                            }
                        />
                        <Stack direction={"row"} alignItems={"center"} gap={1}>
                            <CustomSelectInput
                                fullWidth={false}
                                labelSize={"14px"}
                                sx={{ width: 150 }}
                                label={"Year"}
                                options={yearsOptions}
                                value={year}
                                onChange={handleYearChange}
                                placeholder={"Select Year"}
                                disableClearable={true}
                                highlight={true}
                            />
                            <CustomSelectInput
                                fullWidth={false}
                                labelSize={"14px"}
                                sx={{ width: 160 }}
                                label={"Month"}
                                options={monthsOptions}
                                value={month}
                                onChange={handleMonthChange}
                                placeholder={"Select Month"}
                                disableClearable={true}
                                disabled={!year}
                                highlight={true}
                            />

                            {localStorage.getItem("roleName") !== "DeptUser" && (access?.canCreate || deptVendorAccess) && (
                                <CreateNewButton onClick={handlecreate} />
                            )}

                            <RefreshExportButtons
                                pagination={activeTab === 3 ? true:false}
                                exportFunction={() => { }}
                                exportData={filteredRows}
                                refData={gridApi}
                                customObj={activeTab === 3 ? tab3Columns : customColumns}
                                handleRefresh={handleRefresh}
                                title={
                                    activeTab === 3
                                        ? `New Work Requests `
                                        : activeTab === 0
                                            ? `All Work Orders `
                                            : activeTab === 1
                                                ? `Scheduled Work Orders`
                                                : activeTab === 2
                                                    ? `Unscheduled Work Orders `
                                                    : activeTab === 5
                                                        ? `Routine Inspection (RI) `
                                                        : `Predictive Maintenance (PDM) `
                                }
                                enablePDF={false}
                            />
                        </Stack>
                    </Box>
                    <CustomAgGrid
                        rows={filteredRows}
                        columns={activeTab === 3 ? tab3Columns : columns}
                        handleEdit={localStorage.getItem("roleName") !== "DeptUser" && (access?.canEdit || deptVendorAccess) && handleEdit}
                        handleView={(access?.canView || deptVendorAccess) && handleView}
                        {...(canRenderEmailProp && {
                            handleEmailSend: (rowData) => handleEmailSend(rowData),
                        })} ref={gridApi}
                        setGridApi={setGridApi}
                        handleDownload={
                            (activeTab === 0 || activeTab === 1 || activeTab === 2) && access?.canPrint
                                ? (rowData) => handleDownload(rowData)
                                : undefined
                        }
                        isPinnedRight={true}
                        isLoading={isLoading}
                        pagination={true}
                        actionwidth={160}
                        rowSelection="multiple"
                        suppressRowClickSelection={true} // Prevent row selection on row click
                        onSelectionChanged={onSelectionChanged}
                        isRowSelectable={isRowSelectable} // Allow only "Completed" rows to be selectable
                    />
                    <NoAccessDialog />
                </DefaultCard>
            </Box>

            <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center" style={{ marginTop: 16 }}>
                {localStorage.getItem("roleName") !== "DeptUser" && access?.canAuthorize && activeTab !== 3 && (
                    <Button
                        onClick={openDialog} // Open confirmation dialog
                        variant="contained"
                        // color="primary"
                        disabled={!isAnyRowSelected} // Disable if no rows are selected
                    >
                        Authorize
                    </Button>
                )}
                <CloseButton />
            </Stack>


            {/* Confirmation Dialog */}
            <Dialog
                open={isDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        closeDialog(); // Only close if triggered explicitly
                    }
                }}
            >
                <DialogTitle>Confirm Bulk Authorize</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to authorize the selected work orders?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <Button onClick={confirmAuthorization} color="primary" variant="contained">
                        Yes
                    </Button>
                    <Button onClick={closeDialog} color="primary" variant="outlined">
                        No
                    </Button>
                </DialogActions>
            </Dialog>



            <Dialog
                open={open}
                onClose={(e, reason) => handleDialogClose(e, reason, handleCloseModel)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Respond Work Order</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Do you want to Respond this Work Order {selectedWorkOrderNo}?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={(rowData) => {
                            handleSave(rowData); // Trigger save when clicking Yes
                        }}
                        color="primary"
                        variant="contained"
                    >
                        YES
                    </Button>
                    <Button onClick={handleCloseWithoutFetch} color="primary" variant="outlined">
                        NO
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
                open={openSuccessDialog}
                onClose={(e, reason) => handleDialogClose(e, reason, handleCloseModel)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Success</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">The Work Order has been Responded Successfully.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModel} color="primary" variant="contained">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal
                open={openModal}
                onClose={handleCloseModal} // Pass the handler directly
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={modalStyle}>
                    <Box sx={headerStyle}>
                        <Typography id="modal-title" variant="h5" component="h2">Send Link With</Typography>
                        <IconButton onClick={() => setOpenModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <br />
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                            <Box sx={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                {/* Email Icon */}
                                <Box
                                    onClick={() => handleEmailClick()}
                                    sx={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        '&:hover img': { transform: 'scale(1.2)' },
                                        '&:hover': { color: 'primary.main' },
                                    }}
                                >
                                    <img
                                        src={Email}
                                        alt="Email"
                                        style={{ width: 40, height: 40, objectFit: 'contain', transition: 'transform 0.3s ease' }}
                                    />
                                    <Typography variant="body2">Email</Typography>
                                </Box>

                                {/* Outlook Icon */}
                                <Box
                                    onClick={handleOutlookClick}
                                    sx={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        '&:hover img': { transform: 'scale(1.2)' },
                                        '&:hover': { color: 'primary.main' },
                                    }}
                                >
                                    <img
                                        src={Outlook}
                                        alt="Outlook"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            objectFit: 'contain',
                                            transition: 'transform 0.3s ease',
                                        }}
                                    />
                                    <Typography variant="body2">Outlook</Typography>
                                </Box>

                                {/* WhatsApp Icon */}
                                <Box
                                    onClick={() => handleWhatsAppClick()}
                                    sx={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        '&:hover img': { transform: 'scale(1.2)' },
                                        '&:hover': { color: 'primary.main' },
                                    }}
                                >
                                    <img
                                        src={Whatsapp}
                                        alt="Whatsapp"
                                        style={{ width: 40, height: 40, objectFit: 'contain', transition: 'transform 0.3s ease' }}
                                    />
                                    <Typography variant="body2">WhatsApp</Typography>
                                </Box>
                            </Box>
                        </Stack>

                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button onClick={() => setOpenModal(false)} variant="outlined" color="primary">
                                Cancel
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>;
            <Modal
                open={Boolean(openReportModal)} // Ensure modal only opens if a component is set
                sx={{
                    "& .MuiBackdrop-root": {
                        backgroundColor: "transparent",
                    },
                    top: "-9999px",
                    left: "-9999px",
                    zIndex: "-1",
                }}
            >
                <Box sx={ModalStyle}>
                    {/* Conditionally render either Workreport or Unscheduleworkreport */}
                    {openReportModal === "Workreport" && (data != null) && (
                        <Workreport
                            ref={printRef}
                            data={data}
                            serviceType={serviceType}
                            rowData={selectedRowData}
                        />
                    )}
                    {openReportModal === "Unscheduleworkreport" && (data != null) && (
                        <Unscheduleworkreport
                            ref={printRef}
                            data={data}
                            serviceType={serviceType}
                            rowData={selectedRowData}
                        />
                    )}
                </Box>
            </Modal>


            <Dialog open={signatureDialog} onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    handleSignatureCloseDialog();
                }
            }} >
                <DialogContent>
                    <SignatureGrid
                        onCancel={handleSignatureCloseDialog}
                        onClear={handleSignatureCloseDialog}
                        onSave={(data) => handleSaveSignature(data)}
                        rowData={selectedRowData}
                    // rowData={signatureRows.find((row) => row.id === selectedRowId)}
                    />
                </DialogContent>
            </Dialog>
            <CustomAlert
                open={verifyDialog}
                onClose={handleCloseRequestDialog}
                onConfirm={handleConfirmRequestDialog}
                content={`${selectedRowData?.workorderno} Verified Successfully`}
                confirmBtn='OK'
            />
        </>
    );
};

export default WorkOrderSummaryList;
